/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Secondary_Goal_QuestionInputs */

const en_us2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any second goal?`)
};

const pt_br2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algum segundo objetivo?`)
};

const es_419_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Algún segundo objetivo?`)
};

const pt_pt2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algum segundo objetivo?`)
};

const fr_fr2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un second objectif ?`)
};

const de_de2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein zweites Ziel?`)
};

const it_it2_onboarding_secondary_goal_question = /** @type {(inputs: Onboarding_Secondary_Goal_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai un secondo obiettivo?`)
};

/**
* | output |
* | --- |
* | "Any second goal?" |
*
* @param {Onboarding_Secondary_Goal_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_secondary_goal_question = /** @type {((inputs?: Onboarding_Secondary_Goal_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Secondary_Goal_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_secondary_goal_question(inputs)
	if (locale === "es-419") return es_419_onboarding_secondary_goal_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_secondary_goal_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_secondary_goal_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_secondary_goal_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_secondary_goal_question(inputs)
	return en_us2_onboarding_secondary_goal_question(inputs)
});
export { onboarding_secondary_goal_question as "onboarding.secondary_goal.question" }